import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";

const faqs = [
  {
    question: "Burgelijke aansprakelijkheid",
    answer:
      "De waarborg burgelijke aansprakelijkheid dekt de aansprakelijkheid van jouw als eigenaar van een vaartuig. Of je nu een zeilboot, motorboot, jetski of RIB hebt, je bent altijd verplicht om deze verzekering af te sluiten wanneer je vaartuig over vlaggenbrief moet beschikken. De waarborg burgelijke aansprakelijkheid is een waarborg die tussekomst kan bieden voor schade die wordt toegebracht aan derden. Dit kan lichamelijke maar materiele schade zijn.",
  },
  {
    question: "Bescherming en verlies",
    answer:
      "Deze waarborg verzekert het vaartuig tegen schade door onvoorziene gebeurtenissen zoals aanvaringen, brand, zinken, blikseminslag of storm. Ook schade door vandalisme of een onopzettelijke aanvaring met een obstakel wordt gedekt. In geval van diefstal of totaal verlies van het vaartuig wordt een vergoeding voorzien op basis van de verzekerde waarde, mits voldaan wordt aan de voorzorgsmaatregelen. Sommige contracten bieden extra bescherming voor bijboten, trailers en toebehoren.",
  },
  {
    question: "Lichtingskosten, hulp en berging",
    answer:
      "Deze waarborg dekt de kosten voor het lichten en bergen van het vaartuig wanneer het door een ongeval gezonken of beschadigd is. Ook de kosten voor het vrijmaken van vaarwegen of het opruimen van wrakstukken zijn onder bepaalde omstandigheden gedekt. Het kan gaan om verplichte ingrepen door overheidsinstanties of om dringende noodhulp na een incident op het water. De verzekering zorgt ervoor dat u niet zelf opdraait voor de hoge kosten van hulpverlening of bergingsacties tot het opgenomen plafond.",
  },
  {
    question: "Rechtsbijstand",
    answer:
      "De waarborg rechtsbijstand biedt juridische ondersteuning bij geschillen die voortvloeien uit het gebruik van uw pleziervaartuig. Dit omvat onder andere hulp bij schadeclaims, juridische verdediging na ongevallen en bijstand wanneer u schade hebt geleden door een tegenpartij. De verzekering dekt onder meer de kosten voor juridisch advies en de verdediging van uw belangen in gerechtelijke procedures na een verzekerd schadegeval.  Deze waarborg richt zich specifiek op situaties waarbij u betrokken raakt bij juridische kwesties tijdens het varen, zoals bij aansprakelijkheidskwesties of bij schadevergoedingen.",
  },
  {
    question: "Persoonlijke ongevallen",
    answer:
      "Deze waarborg beschermt de opvarenden en de eigenaar tegen de financiële gevolgen van lichamelijke ongevallen aan boord. Bij blijvende invaliditeit of overlijden door een ongeval voorziet de verzekering een uitkering aan de verzekerde of diens nabestaanden. Ook medische kosten en revalidatiekosten kunnen verzekerd zijn binnen deze waarborg. De exacte vergoedingen zijn afhankelijk van het verzekeringscontract, maar zijn in alle gevallen gericht op het beschermen van de personen aan boord.",
  },
];

export default function Example() {
  return (
    <div>
      <section>
        <div className="mx-auto max-w-7xl px-6 py-10 sm:py-16 lg:px-8 lg:py-12">
          <div className="mx-auto max-w-4xl">
            <h2 className="text-4xl font-semibold tracking-tight text-[#1a2a6c] sm:text-5xl">
              Op zoek naar{" "}
              <span className="text-[#ff6f61]">meer informatie?</span>
            </h2>
            <h4 className="text-xl tracking-tight text-[#1a2a6c] sm:text-2xl mt-4">
              Bij boot-verzekering.be bieden we uitgebreide en op maat gemaakte
              verzekeringen aan zodat jij altijd goed beschermd bent. Lees
              hieronder wat onze waarborgen voor jou kunnen betekenen.
            </h4>

            {/* Blauwe lijn tussen h4 en dl */}
            <div className="mt-6 mb-10 flex justify-start">
              <hr className="w-2/5 border-t-2 border-[#1a2a6c]" />
            </div>

            <dl className="space-y-6 divide-y divide-gray-300">
              {faqs.map((faq) => (
                <Disclosure key={faq.question} as="div" className="pt-6">
                  <dt>
                    <DisclosureButton className="group flex w-full items-start justify-between text-left text-[#ff6f61] bg-transparent hover:bg-[#1a2a6c] hover:text-white rounded-md px-4 py-2">
                      <span className="text-base font-semibold leading-7">
                        {faq.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        <PlusSmallIcon
                          aria-hidden="true"
                          className="h-6 w-6 group-data-[open]:hidden"
                        />
                        <MinusSmallIcon
                          aria-hidden="true"
                          className="h-6 w-6 [.group:not([data-open])_&]:hidden"
                        />
                      </span>
                    </DisclosureButton>
                  </dt>
                  <DisclosurePanel as="dd" className="mt-2 pr-12 pl-4">
                    <p className="text-base leading-7 text-[#1a2a6c]">
                      {faq.answer}
                    </p>
                  </DisclosurePanel>
                </Disclosure>
              ))}
            </dl>
          </div>
        </div>
      </section>

      <section>
        <div className="mx-auto max-w-7xl px-6 py-10 sm:py-16 lg:px-8 lg:py-12">
          <h2 className="text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
            Bij <span className="underline">boot-verzekering.be</span> helpen
            wij jou navigeren naar{" "}
            <span className="text-[#ff6f61]">de beste verzekering</span> voor
            jouw vaartuig. Vraag nu jouw{" "}
            <span className="text-[#ff6f61]">offerte</span> aan!
          </h2>
          <div className="mt-10 flex items-center gap-x-6">
            <a
              href="/verzekeringsmodule"
              className="rounded-md bg-[#1a2a6c] px-5 py-3 text-base font-bold text-[#ff6f61] shadow-lg hover:bg-[#142057] hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1a2a6c]"
            >
              Ja, ik wil mijn vaartuig verzekeren
            </a>
          </div>
        </div>
      </section>

      {/* Tussenlijn in accentkleur */}
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <hr className="ml-auto w-3/4 border-t-2 border-[#ff6f61]" />
      </div>

      <section>
        <div className="py-10 sm:py-16 lg:py-16">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <h2 className="max-w-2xl text-balance text-3xl font-semibold tracking-tight text-[#1a2a6c] sm:text-4xl">
              Niet gevonden wat je zocht? Check onze FAQ pagina{" "}
              <a href="/faq" className="text-[#ff6f61] underline">
                hier
              </a>
            </h2>
          </div>
        </div>
      </section>
    </div>
  );
}
